import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchDefaultInstallerPay,
  updateDefaultInstallerPay,
  bulkUpdateDefaultInstallerPay,
} from 'actionCreators/default_installer_pay';
import { requestPricePatchesList } from 'actionCreators/dropdown_lists';
import { getPricePatchesList } from '../../../../reducers';
import DefaultInstallerPayRow from './DefaultInstallerPayRow';
import ColoredButton from 'components/ColoredButton';
import Loading from 'components/Loading';
import PageActionBar from 'components/PageActionBar';
import ReactSelect from 'components/StyledSelect/react_select';
import contentAreaStyles from 'styles/contentArea';

const floatingBarStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: '#fff',
  borderTop: '2px solid #ddd',
  padding: '12px 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  boxShadow: '0 -2px 8px rgba(0,0,0,0.12)',
  zIndex: 1000,
};

class DefaultInstallerPay extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedPricePatch: null, dirtyItems: {} };
  }

  componentWillMount() {
    this.props.requestPricePatchesList();
    this.props.fetchDefaultInstallerPay(null);
  }

  handlePricePatchChange = (option) => {
    const id = option ? option.value : null;
    this.setState({ selectedPricePatch: option, dirtyItems: {} });
    this.props.fetchDefaultInstallerPay(id);
  }

  handleSave = (id, cents) => {
    this.props.updateDefaultInstallerPay(id, cents);
  }

  handleDirtyChange = (id, cents) => {
    this.setState((prevState) => {
      const dirtyItems = { ...prevState.dirtyItems };
      if (cents === null) {
        delete dirtyItems[id];
      } else {
        dirtyItems[id] = cents;
      }
      return { dirtyItems };
    });
  }

  handleSaveAll = () => {
    const { dirtyItems } = this.state;
    const items = Object.keys(dirtyItems).map(id => ({
      id: Number(id),
      default_installer_pay: dirtyItems[id],
    }));
    this.props.bulkUpdateDefaultInstallerPay(items);
  }

  render() {
    const { patchItems, pricePatches, loading } = this.props;
    const { selectedPricePatch, dirtyItems } = this.state;
    const pricePatchOptions = pricePatches.map(pp => ({ value: pp.id, label: pp.name }));
    const dirtyCount = Object.keys(dirtyItems).length;

    return (
      <div>
        <PageActionBar
          showAdd={false}
          showFiltersBtn={false}
          title="Default Installer Pay"
        />
        <div className={contentAreaStyles.contentAreaContainer} style={{ paddingBottom: '64px' }}>
          <div style={{ maxWidth: '300px', marginBottom: '16px' }}>
            <ReactSelect
              label="Price Patch (LCZ)"
              name="price_patch"
              placeholder="All LCZs"
              options={pricePatchOptions}
              value={selectedPricePatch}
              onChange={this.handlePricePatchChange}
              clearable
            />
          </div>
          {loading && <Loading />}
          {!loading && (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' }}>Item Number</th>
                  <th style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' }}>LCZ</th>
                  <th style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' }}>Description</th>
                  <th style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' }}>Default Pay ($)</th>
                </tr>
              </thead>
              <tbody>
                {patchItems.map(item => (
                  <DefaultInstallerPayRow
                    key={item.id}
                    patchItem={item}
                    onSave={this.handleSave}
                    onDirtyChange={this.handleDirtyChange}
                  />
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div style={floatingBarStyle}>
          <span style={{ marginRight: '16px', color: dirtyCount > 1 ? '#333' : '#999' }}>
            {dirtyCount === 1
              ? 'Bulk Save - only 1 unsaved change'
              : `Bulk Save - ${dirtyCount > 0 ? `${dirtyCount} unsaved changes` : 'No unsaved changes'}`}
          </span>
          <ColoredButton
            label="Save All"
            color="green"
            disabled={dirtyCount <= 1}
            onClick={this.handleSaveAll}
          />
        </div>
      </div>
    );
  }
}

DefaultInstallerPay.defaultProps = {
  patchItems: [],
  pricePatches: [],
  loading: false,
};

DefaultInstallerPay.propTypes = {
  patchItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    item_number: PropTypes.string,
    description: PropTypes.string,
    default_installer_pay: PropTypes.number,
    price_patch_name: PropTypes.string,
  })),
  pricePatches: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
  loading: PropTypes.bool,
  fetchDefaultInstallerPay: PropTypes.func.isRequired,
  updateDefaultInstallerPay: PropTypes.func.isRequired,
  bulkUpdateDefaultInstallerPay: PropTypes.func.isRequired,
  requestPricePatchesList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  patchItems: state.defaultInstallerPay.patchItems,
  pricePatches: getPricePatchesList(state),
  loading: state.defaultInstallerPay.loading,
});

const mapDispatchToProps = {
  fetchDefaultInstallerPay,
  updateDefaultInstallerPay,
  bulkUpdateDefaultInstallerPay,
  requestPricePatchesList,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultInstallerPay);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/defaultInstallerPay/index.jsx